import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LoadingService } from './shared/services/loading/loading.service';
import Swal from 'sweetalert2';
import { ToastService } from './shared/services/toast/toast.service';
import { ISwal } from './shared/services/toast/iswal';
import { KeyboardService } from './shared/components/keyboard/keyboard.service';
import { Subscription } from 'rxjs';
import * as io from 'socket.io-client';
import { API_PATH } from 'src/environments/environment';
import { AuthService } from './views/auth/shared/auth.service';
import { ToastTypeEnum } from './shared/services/toast/toast-type-enum';
import { ThemeService } from './shared/services/theme/theme.service';

export function getSocketUrl(
  apiPath: string,
  pageProtocol = window.location.protocol
): string {
  const url = new URL(apiPath);
  url.protocol = pageProtocol === 'https:' ? 'https:' : 'http:';
  return url.origin;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'WAZIR ERP';
  @ViewChild('keyboard')
  keyboard: any;
  settingsSub: Subscription;
  activeSwalId: string | null = null;

  constructor(
    public loadingService: LoadingService,
    private toastService: ToastService,
    public keyboardService: KeyboardService,
    private authService: AuthService,
    private themeService: ThemeService
  ) { }

  ngOnInit(): void {
    this.themeService.initialize();

    this.toastService.swalFire.subscribe((data: ISwal) => {
      if (data.close && data.id) {
        Swal.close();
        this.activeSwalId = null;
        return;
      }

      if (data.update && data.id) {
        const toast = Swal.getPopup();
        if (toast) {
          Swal.update({
            title: data.title,
            html: data.enableHtml ? data.text : undefined,
            text: data.enableHtml ? undefined : data.text
          });
        } else {
          this.showNotification(data);
        }
        return;
      }

      this.showNotification(data);
    });

    const ioClient = io.connect(getSocketUrl(API_PATH));
    ioClient.on(
      `progress-${this.authService.getAuthorizationToken()}`,
      (progress) => this.loadingService.setProgress(progress)
    );
  }

  private showNotification(data: ISwal): void {
    if (data.id) {
      this.activeSwalId = data.id;
    }

    const swalOptions: any = {
      ...data,
      didOpen: (toast: HTMLElement) => {
        if (data.timerProgressBar) {
          const timerProgressBar = toast.querySelector('.swal2-timer-progress-bar') as HTMLElement;
          if (timerProgressBar) {
            timerProgressBar.style.display = 'block';
          }
        }

        if (data.icon) {
          const iconType = data.icon.toString();
          toast.classList.add(`swal2-${iconType}`);
        }
      }
    };

    if (data.icon === ToastTypeEnum.PERMISSION || data.icon === ToastTypeEnum.INTERNAL) {
      swalOptions.toast = false;
      swalOptions.position = 'center';
      swalOptions.backdrop = `rgba(0,0,0,0.5)`;
      swalOptions.allowOutsideClick = false;

      if (!swalOptions.customClass) {
        swalOptions.customClass = {};
      }

      if (data.icon === ToastTypeEnum.PERMISSION) {
        swalOptions.customClass.container = 'permission-container';
        swalOptions.customClass.popup = 'permission-popup';
      } else if (data.icon === ToastTypeEnum.INTERNAL) {
        swalOptions.customClass.container = 'internal-container';
        swalOptions.customClass.popup = 'internal-popup';
      }
    }

    if (data.enableHtml) {
      swalOptions.html = data.text;
      delete swalOptions.text;
    }

    Swal.fire(swalOptions).then((result) => {
      if (data.actionButton && result.isConfirmed) {
        data.actionButton.action();
      }

      if (data.icon === ToastTypeEnum.INTERNAL && result.isDenied && data.showDenyButton) {
      }

      this.activeSwalId = null;
    });
  }

  ngOnDestroy(): void {
    if (this.settingsSub) {
      this.settingsSub.unsubscribe();
    }
  }
}
